import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c114d33e&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c114d33e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c114d33e')) {
      api.createRecord('c114d33e', component.options)
    } else {
      api.reload('c114d33e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c114d33e&lang=pug", function () {
      api.rerender('c114d33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/privacy/index.vue"
export default component.exports